import Environment from '../constants/Environment.esm.js';

var _HOST_BY_ENVIRONMENT;
var HOST_BY_ENVIRONMENT = (_HOST_BY_ENVIRONMENT = {}, _HOST_BY_ENVIRONMENT[Environment.DEVELOPMENT] = 'localhost', _HOST_BY_ENVIRONMENT[Environment.SANDBOX] = 'sandbox-ezcater.com', _HOST_BY_ENVIRONMENT[Environment.STAGING] = 'staging-ezcater.com', _HOST_BY_ENVIRONMENT);
var getEnvironment = function getEnvironment(currentWindow) {
  var environments = Object.keys(Environment).map(function (key) {
    return Environment[key];
  });
  var matchingEnvironment = environments.filter(function (environment) {
    var host = HOST_BY_ENVIRONMENT[environment];
    return currentWindow.location.hostname.indexOf(host) >= 0;
  })[0];
  return matchingEnvironment || Environment.PRODUCTION;
};

export { getEnvironment };
//# sourceMappingURL=getEnvironment.esm.js.map
